import React, { useState } from "react";
import { Package, Loader2, ChevronRight } from "lucide-react";
import { postData } from "../../services/NodeServices";
import { useNavigate } from "react-router-dom";

export default function CancelOrder() {
  const [reason, setReason] = useState('');
  const [customReason, setCustomReason] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const orderId = new URLSearchParams(window.location.search).get('orderId');
const action = new URLSearchParams(window.location.search).get('action');

  const navigate = useNavigate()
  
  // Mock query params - replace with actual implementation
 
 

  const predefinedReasons = [
    "Received damaged product",
    "Order size was incorrect", 
    "Order was not as described",
    "Changed my mind",
    "Found better price elsewhere",
    "Delivery taking too long",
    "Ordered by mistake",
    "Product no longer needed"
  ];

  const handleReasonSelect = (selectedReason) => {
    setReason(selectedReason);
    if (selectedReason !== "Other") {
      setCustomReason('');
    }
  };

  

 const handleRequestCancel = async() => {
 
 
 
 try{
     const result = await postData(`api/order/cancel-order`, {
         orderId: orderId,
         action: action,
         reason: reason
     });   
 
     if(result && result.status){
         // Navigate to success page
         navigate('/cancel-success');    
         
     }
     
 }
 catch(err){
 console.log("Error confirming cancellation:", err);
 }
 
 
 
 
 
 }
 

  if (!orderId || !action) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg border border-gray-200 p-6 max-w-sm w-full text-center">
          <h2 className="text-lg font-medium text-gray-900 mb-2">Invalid Request</h2>
          <p className="text-sm text-gray-600">Please provide a valid order ID and action.</p>
        </div>
      </div>
    );
  }

  const finalReason = reason === "Other" ? customReason : reason;
  const canSubmit = reason && (reason !== "Other" || customReason.trim());

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg border border-gray-200 max-w-md w-full overflow-hidden">
        
        <div className="bg-orange-500 p-4 text-white">
          <div className="flex items-center gap-3">
            <Package className="w-5 h-5" />
            <div>
              <h1 className="text-base font-medium">Cancel Order</h1>
              <p className="text-xs text-orange-100">Order #{orderId}</p>
            </div>
          </div>
        </div>

        <div className="p-4">
          <div className="mb-4">
            <h2 className="text-sm font-medium text-gray-900 mb-1">
              Select cancellation reason
            </h2>
            <p className="text-xs text-gray-500">
              Choose the option that best describes your situation
            </p>
          </div>

          <div className="max-h-48 overflow-y-auto space-y-2 mb-4 pr-1">
            {predefinedReasons.map((item) => (
              <div
                key={item}
                onClick={() => handleReasonSelect(item)}
                className={`
                  flex items-center justify-between p-3 rounded-md border cursor-pointer transition-colors duration-150
                  ${reason === item 
                    ? 'border-orange-300 bg-orange-50' 
                    : 'border-gray-200 hover:border-orange-200 hover:bg-orange-25'
                  }
                `}
              >
                <span className={`text-sm ${reason === item ? 'text-orange-700' : 'text-gray-700'}`}>
                  {item}
                </span>
                <ChevronRight className={`w-4 h-4 transition-transform duration-150 ${
                  reason === item ? 'text-orange-500 rotate-90' : 'text-gray-400'
                }`} />
              </div>
            ))}

            <div
              onClick={() => handleReasonSelect("Other")}
              className={`
                flex items-center justify-between p-3 rounded-md border cursor-pointer transition-colors duration-150
                ${reason === "Other" 
                  ? 'border-orange-300 bg-orange-50' 
                  : 'border-gray-200 hover:border-orange-200'
                }
              `}
            >
              <span className={`text-sm ${reason === "Other" ? 'text-orange-700' : 'text-gray-700'}`}>
                Other reason
              </span>
              <ChevronRight className={`w-4 h-4 transition-transform duration-150 ${
                reason === "Other" ? 'text-orange-500 rotate-90' : 'text-gray-400'
              }`} />
            </div>
          </div>

          {reason === "Other" && (
            <div className="mt-3 p-3 bg-orange-50 rounded-md border border-orange-200 mb-4">
              <textarea
                value={customReason}
                onChange={(e) => setCustomReason(e.target.value)}
                placeholder="Describe your reason..."
                className="w-full p-2 border border-orange-200 rounded text-sm resize-none focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500"
                rows="2"
                maxLength="200"
              />
              <div className="text-right mt-1">
                <span className="text-xs text-gray-500">
                  {customReason.length}/200
                </span>
              </div>
            </div>
          )}

          <div className="flex gap-2 pt-3 border-t border-gray-100">
            <button
              onClick={() => window.history.back()}
              className="flex-1 px-3 py-2 text-sm text-gray-600 bg-white border border-gray-200 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-gray-400 transition-colors duration-150"
            >
              Back
            </button>
            
            <button
              onClick={handleRequestCancel}
              disabled={!canSubmit || isLoading}
              className={`
                flex-1 px-3 py-2 text-sm rounded-md transition-colors duration-150 flex items-center justify-center gap-2
                ${canSubmit && !isLoading
                  ? 'bg-orange-500 hover:bg-orange-600 text-white focus:outline-none focus:ring-1 focus:ring-orange-500' 
                  : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                }
              `}
            >
              {isLoading ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin" />
                  Processing
                </>
              ) : (
                'Confirm'
              )}
            </button>
          </div>

          <div className="mt-3 p-2 bg-gray-50 rounded-md border border-gray-100">
            <p className="text-xs text-gray-600">
              This action cannot be undone. Already shipped orders may require returns.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}